<div class="main-menu" *ngIf="Device === DTypes.Desktop">
  <div class="pg-wrapper">
    <div class="grid align-items-center justify-content-between">
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
      <div class="col-auto main-menu__link" routerLink="/{{Routing.Bulletins}}"  routerLinkActive="active">
        <a routerLink="/{{Routing.Bulletins}}" routerLinkActive="active">Поиск музыкантов</a>
      </div>
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
      <div class="col-auto main-menu__link" routerLink="/{{Routing.Loyalty}}" routerLinkActive="active">
        <a routerLink="/{{Routing.Loyalty}}">Программа лояльности</a>
      </div>
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
      <div class="col-auto main-menu__link" routerLink="/{{Routing.Market}}" routerLinkActive="active">
        <a routerLink="/{{Routing.Market}}">Музыкальная барахолка</a>
      </div>
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
      <div class="col-auto main-menu__link" routerLink="/{{Routing.Calendar}}" routerLinkActive="active">
        <a routerLink="/{{Routing.Calendar}}">Календарь событий</a>
      </div>
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
      <div class="col-auto main-menu__link" routerLink="/{{Routing.News}}" routerLinkActive="active">
        <a routerLink="/{{Routing.News}}" title="Новости">Новости</a>
      </div>
      <div class="col-auto main-menu__divider">
        <span>#</span>
      </div>
    </div>
  </div>
</div>

<div class="main-menu" *ngIf="Device === DTypes.Mobile">
  <div class="main-menu__link-mobile" routerLink="/{{Routing.Bulletins}}" routerLinkActive="active">
    <a routerLink="/{{Routing.Bulletins}}">Поиск музыкантов</a>
  </div>
  <div class="main-menu__link-mobile" routerLink="/{{Routing.Loyalty}}" routerLinkActive="active">
    <a routerLink="/{{Routing.Loyalty}}">Программа лояльности</a>
  </div>
  <div class="main-menu__link-mobile" routerLink="/{{Routing.Market}}" routerLinkActive="active">
    <a routerLink="/{{Routing.Market}}">Музыкальная барахолка</a>
  </div>
  <div class="main-menu__link-mobile" routerLink="/{{Routing.Calendar}}" routerLinkActive="active">
    <a routerLink="/{{Routing.Calendar}}">Календарь событий</a>
  </div>
  <div class="main-menu__link-mobile" routerLink="/{{Routing.News}}" routerLinkActive="active">
    <a routerLink="/{{Routing.News}}" title="Новости">Новости</a>
  </div>
</div>
